import { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import Button from 'jbc-front/components/Button';
import { Spacer } from 'jbc-front/components/presenters/Spacer';
import { Input } from 'jbc-front/components/presenters/form/Input';
import { Section, Label } from 'jbc-front/components/Form';
import { ErrorMessage } from 'jbc-front/components/presenters/form/ErrorMessage';
import styles from './HealthCheckupInstitutionForm.scss';
import type { Schema } from '../schema';

interface FormProps {
  onSubmit: () => void;
  onCancel: () => void;
}

export const HealthCheckupInstitutionForm: FC<FormProps> = ({ onSubmit, onCancel }) => {
  const {
    register,
    formState: { errors, isSubmitting }
  } = useFormContext<Schema>();

  return (
    <form>
      <div className={styles.forms}>
        <Section title="健康診断実施機関情報">
          <Label text="ID" required />
          <div className={styles.notes}>半角英数5文字まで ※-（半角ハイフン）、_（半角アンダーバー）を含む</div>
          <Input {...register('healthCheckupInstitutionId')} />
          {errors.healthCheckupInstitutionId?.message && (
            <ErrorMessage>{errors.healthCheckupInstitutionId.message}</ErrorMessage>
          )}

          <Spacer size={20} />

          <Label text="健康診断実施機関名" required />
          <div className={styles.notes}>健康診断実施機関名の名称を入力してください（120字以内）</div>
          <Input {...register('name')} />
          {errors.name?.message && <ErrorMessage>{errors.name.message}</ErrorMessage>}

          <Spacer size={20} />

          <Label text="所在地" required />
          <div className={styles.notes}>健康診断実施機関名の所在地を入力してください（120字以内）</div>
          <Input {...register('location')} />
          {errors.location?.message && <ErrorMessage>{errors.location.message}</ErrorMessage>}
        </Section>
      </div>

      <div className="u-ta-c u-mt30">
        <Button className="u-mr20" onClick={onCancel} disabled={isSubmitting}>
          キャンセル
        </Button>
        <Button primary onClick={onSubmit} disabled={isSubmitting}>
          保存
        </Button>
      </div>
    </form>
  );
};
